module.exports = __webpack_public_path__ + "img/isracard.cc1773cb.png";